import { CustomBarChart } from '../component';

export const Charts = ({ dataset }) => {
    const type = dataset?.chartType || ChartType.verticalBar
    const renderCustomCharts = () => {
        switch (type) {
            case ChartType.horizontalBar:
            case ChartType.verticalBar:
                return <CustomBarChart dataset={dataset} />;
            default:
                break;
        }
    }
    return (
        <div style={{ height: 380 }}>
            {renderCustomCharts()}
        </div>
    )
}

export const ChartType = {
    horizontalBar: "horizontal",
    verticalBar: "vertical",
}